import { TemplateRef } from '@angular/core';

export class FlyInModalArgs {
  Content: TemplateRef<any>;
  Header: string;

  constructor(header: string, content: TemplateRef<any>) {
    this.Content = content;
    this.Header = header;
  }
}

export class ModalMessage {
  Body: string;
  IsHtml: boolean;

  constructor(msg: string, isHtml: boolean) {
    this.Body = msg;
    this.IsHtml = isHtml;
  }
}

export class ModalArgs {
  Message: ModalMessage;
  State: ModalStates;
  RouteCommands: any;
  CancelButtonText: string;
  ConfirmButtonText: string;
  Header: string;
  HideOkButton: boolean;

  constructor(
    message: ModalMessage,
    state: ModalStates = null,
    cmd?: any,
    cancelTxt?: string,
    confirmTxt?: string,
    header?: string,
    html?: string
  ) {
    this.Message = message;
    this.State = state;
    this.RouteCommands = cmd;
    this.CancelButtonText = cancelTxt || 'Cancel';
    this.ConfirmButtonText = confirmTxt || 'Confirm';
    this.Header = header;
    this.HideOkButton = false;
  }
}

export enum ModalStates {
  Error = 0,
  Success = 1,
  Warning = 2,
  Info = 3
}
